import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";

import SecureLS from "secure-ls";
var ls = new SecureLS({ isCompression: false });

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import pharmacy from "./pharmacy.module"
import notification from "./notification.module"

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    pharmacy,
    notification
  },
  plugins: [
    createPersistedState({
      paths: ["auth", "pharmacy", "notification"],
      key : "app",
      storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key)
      }
    })
  ]
});
